import _ from 'lodash';

const TOGGLE_LEFT_SIDE_MENU = 'page/TOGGLE_LEFT_SIDE_MENU';

export const toggleLeftSideMenu = ({menuOpen}: {menuOpen: boolean}) => ({
  type: TOGGLE_LEFT_SIDE_MENU,
  payload: {menuOpen}
});

export const getMenuOpenState = state => _.get(state, 'page.menuOpen');

const initialState = {
  menuOpen: true
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LEFT_SIDE_MENU:
      return {...state, menuOpen: action.payload.menuOpen};

    default:
      return state;
  }
};

export default reducer;
